// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"bf8b49a7","372":"a77c7743","450":"aa965214","588":"ef959b1e","638":"f4535880","787":"f18788c0"}[chunkId] + ".chunk.js";
};